import React from 'react'
import ReactDOM from 'react-dom/client'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import App from './App.tsx'
import './index.css'
import { ThemeProvider } from './contexts/ThemeContext.tsx'
import { AuthProvider } from './contexts/AuthContext.tsx'

// Initialize PostHog
if (typeof window !== 'undefined') {
  posthog.init('phc_67dWkHktFLDuxuUy7zOYyyRBwOj25sw3plZHtKjZzy0', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
  })
}

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      registration => {
        //console.log('ServiceWorker registration successful:', registration.scope);
      },
      err => {
        //console.log('ServiceWorker registration failed:', err);
      }
    );
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <ThemeProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </PostHogProvider>
  </React.StrictMode>,
)